import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {//我的班级
      path: '/user/myClassroom',
      name: 'MyClassroom',
      component: resolve=>{
          require(['@/pages/user/MyClassroom'],resolve)
      }
    },
	{//我的班级详情
	  path: '/user/myClassroomDetail',
	  name: 'MyClassroomDetail',
	  component: resolve=>{
	      require(['@/pages/user/MyClassroomDetail'],resolve)
	  }
	},
    {//我的课程
      path: '/user/myCourse',
      name: 'MyCourse',
      component: resolve=>{
          require(['@/pages/user/MyCourse'],resolve)
      }
    },
    {//练习中心
      path: '/user/myExam',
      name: 'MyExam',
      component: resolve=>{
          require(['@/pages/user/MyExam'],resolve)
      }
    },
	{//考试题库
		path: '/user/examBank',
		name: 'ExamBank',
		component: resolve=>{
		    require(['@/pages/user/ExamBank'],resolve)
		}
	},
	{//考试章节列表
		path: '/user/examList',
		name: 'ExamList',
		component: resolve=>{
		    require(['@/pages/user/ExamList'],resolve)
		}
	},
	{//收藏练习
		path: '/user/collectBank',
		name: 'CollectBank',
		component: resolve=>{
		    require(['@/pages/user/CollectBank'],resolve)
		}
	},
	{//错题练习
		path: '/user/errorBank',
		name: 'ErrorBank',
		component: resolve=>{
		    require(['@/pages/user/ErrorBank'],resolve)
		}
	},
	{//考试记录
		path: '/user/examRecord',
		name: 'ExamRecord',
		component: resolve=>{
		    require(['@/pages/user/ExamRecord'],resolve)
		}
  },
  {//折扣卡
    path: '/user/myDiscount',
    name: 'MyDiscount',
    component: resolve=>{
        require(['@/pages/user/MyDiscount'],resolve)
    }
  },
  {//支付方式
    path: '/user/myDiscount/:id',
    name: 'DiscountPayment',
    component: resolve=>{
        require(['@/pages/user/DiscountPayment'],resolve)
    }
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js